<template>
  <div>
    <h2 v-if="localCurrencies.length > 0 && isStablecoinEnabled" class="text-4 text-gray-2 font-semibold mb-4">
      Monedas locales
    </h2>

    <div class="flex flex-col shadow-sm rounded-md px-3">
      <CreateWalletCurrencyCard
        v-for="(currency, key) in localCurrencies"
        :key="key"
        class="text-left"
        :currency="currency"
        @click="emit('currency-selected', currency)"
      />
    </div>

    <template v-if="isStablecoinEnabled && stablecoinCurrencies.length > 0">
      <div class="flex items-center gap-2 mt-6 mb-2">
        <h2 class="text-4 text-gray-2 font-semibold">Stablecoins</h2>
        <GBadgeNew>Nuevo</GBadgeNew>
      </div>
      <div class="flex flex-col shadow-sm rounded-md px-3">
        <CreateWalletCurrencyCard
          v-for="(currency, key) in stablecoinCurrencies"
          :key="key"
          class="text-left"
          :currency="currency"
          @click="emit('currency-selected', currency)"
        />
      </div>
    </template>

  </div>
</template>

<script lang="ts" setup>
// TYPES
import type { CreateWalletCurrencyEmit } from '../../types/createWalletCurrency.type';

// COMPONENTS
import GBadgeNew from '@/components/GBadgeNew.vue';
import CreateWalletCurrencyCard from '../../components/CreateWalletCurrencyCard/index.vue';

// COMPOSABLE
import { useCreateWalletCurrency } from './useCreateWalletCurrency';

const emit = defineEmits<CreateWalletCurrencyEmit>();

const { isStablecoinEnabled, localCurrencies, stablecoinCurrencies } = useCreateWalletCurrency();
</script>
